import React, { createContext } from "react";

const SnackbarContext = createContext<React.MutableRefObject<any> | undefined>(
  undefined
);

export default SnackbarContext;
